import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { SearchService } from '../../shared/search/search.service';
import { Organization } from '../../feature/organizations/models/Organization';

@Injectable({
    providedIn: 'root'
})
export class NavService {

    opened = new ReplaySubject<boolean>();
    public selectedOrg = new BehaviorSubject<Organization | undefined>(undefined);
    public selectedOrgId = new BehaviorSubject<any | undefined>(undefined);
    selectedOrg$ = this.selectedOrg.asObservable();

    constructor(private readonly searchService: SearchService) {}

    ngOnDestroy(): void {
        this.selectedOrg.next(undefined);
        this.selectedOrg.complete();
    }

    public setSelectedOrganization(org: any) {
        this.selectedOrg.next(org);
        if (org?.organizationId > 0) {
            this.selectedOrgId.next(Number(org.organizationId));
            this.searchService.setOrganizationId(org.organizationId);
        }
    }

    public get selectedOrganizationId(): number | undefined {
        return this.selectedOrg.value?.organization_id;
    }

    public removeSelectedOrganization() {
        this.selectedOrg.next(undefined);
        this.selectedOrgId.next(0);
        this.searchService.removeOrganizationId();
    }

    closeSideNav() {
        this.opened.next(false);
    }

    openSideNav() {
        this.opened.next(true);
    }
}